<script>
import { colors } from '@helper/designColors'
export default {
  name: 'BaseTabGrid',
  props: {
    tab: {
      type: String,
      default: 'about'
    },
    activeColor: {
      type: String,
      default: 'primary'
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selectedTab: 'about',
      width: 'w-1/2'
    }
  },
  computed: {
    activeColorBg () {
      return colors[this.activeColor]?.bg || 'bg-primary'
    },
    cursorColor () {
      return colors[this.activeColor]?.bg_disable || 'bg-primary-100'
    },
    activeList () {
      return this.items.filter((val) => { return !val.disabled })
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      this.selectedTab = this.tab
      this.width = 'w-1/' + this.items.length
    },
    changeTab (index, name) {
      this.selectedTab = name
    }
  }
}
</script>

<template>
  <div class="tab-grid">
    <div class="tab-grid__actions">
      <div
        v-for="(item, index) in activeList"
        :key="index"
        :class="[width, activeList.length > 1 ? 'text-center' : 'text-left',
                 {'active': item.name === selectedTab}]"
        class="label"
        @click="changeTab(index,item.name)"
      >
        <span>{{ item.title }}</span>
        <transition name="fade">
          <div v-if="item.name === selectedTab" class="tab-grid__active" :class="[activeColorBg]" />
        </transition>
      </div>
    </div>
    <div class="tab-grid__cursor" :class="cursorColor">
      <div />
    </div>
    <div v-for="(item, index) in items" :key="index">
      <slot
        v-if="selectedTab === item.name"
        :name="item.name"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.tab-grid {
  &__actions {
    @apply flex flex-row relative pb-2 space-x-8 cursor-pointer;
    .label {
      @apply relative flex-1 text-label-text text__body-3-md--semibold;
      &.active {
        @apply text-body-1 lg:text__body-3-md--bold;
      }
    }
  }
  &__cursor {
    @apply  rounded-lg w-full h-1 mb-4;
  }
  &__active {
    @apply  rounded-lg w-full h-1 absolute -bottom-3 transition-all;
  }
}
</style>
